import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./Components/Navbar";
import Footer from "./Components/Footer/Footer";
import AppRoutes from "./Routes/AppRoutes";
import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "./Components/Auth/firebase";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CommonLoader from "./Components/CommonLoader";
import { registerServiceWorker } from "./Components/Firebase/registerServiceWorker";
import { requestPermission } from "./Components/Firebase/requestPermission";
import { listenForForegroundMessages } from "./Components/Firebase/messaging";

import { useLocation } from "react-router-dom";

const AppContent = () => {
  const location = useLocation();
  const knownPaths = [
    '/', '/schemes', '/passbook', '/register', '/profile', 
    '/about', '/contact', '/login', '/privacy-policy', 
    '/terms-and-conditions', '/refund-policy'
  ];
  const isKnownPath = knownPaths.includes(location.pathname);
  const isPdfViewer = !isKnownPath && location.pathname.length > 1;

  return (
    <>
      <div className="app">
        {!isPdfViewer && <Navbar />}
        <main style={isPdfViewer ? { padding: 0, margin: 0 } : {}}>
          <AppRoutes />
        </main>
      </div>
      {!isPdfViewer && <Footer />}
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
};

const App = () => {
  const auth = getAuth();
  const [loading, setLoading] = useState(true);
  // =============== Update customer =============== //
  const updateCustomer = async (uid) => {
    try {
      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setLoading(false);
      } else {
        await setDoc(doc(db, "users", uid), {
          name: "N/A",
          mobile: "N/A",
          email: "N/A",
          sign_in_date: new Date(),
          scheme: 0
        });
        setLoading(false);
      }
    } catch (err) {
      console.error("Error fetching customer data:", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeFCM = async (uid = null) => {
      const registration = await registerServiceWorker();

      if (!registration) return;

      await requestPermission(registration, uid);
      await listenForForegroundMessages();
    };

    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        await updateCustomer(user.uid);
        await initializeFCM(user.uid);
      } else {
        setLoading(false);
        initializeFCM();
      }
    });

    return () => unsubscribe();
  }, [auth]);
  if (loading) {
    return <CommonLoader />;
  }
  return (
    <Router>
      <AppContent />
    </Router>
  );
};

export default App;
